import Help from './Help';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class MinorIssues extends React.Component {

    render() {

        const { classes, allowMinorIssues, onChange, margin } = this.props;

        return (
            <TitledPanel height="full" title="Data Errors" margin={margin} actions={
                <Help textRef="MINOR_ISSUES" position={false} />
            }>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <legend className={classes.hideLegend}>Data errors</legend>
                    <RadioGroup row aria-label="Allow minor issues" name="allowMinorIssues" value={allowMinorIssues.toString()} onChange={onChange}>
                    <FormControlLabel data-test="select-yes" value="true" control={<Radio color="primary" />} label="Ignore Minor"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-no" value="false" control={<Radio color="primary" />} label="Fail All"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
            </TitledPanel>
        );
    }
}

MinorIssues.defaultProps = {
    margin: true
};

MinorIssues.propTypes = {
    allowMinorIssues: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(MinorIssues);